import styled from 'styled-components'

export const HeroText = styled.h4`
  font-size: 1rem;
  line-height: 1.2;
  font-weight: bold;
`
